import React, { FC } from "react";
import { Button as MuiButton } from "@mui/material";

type Props = React.ComponentProps<typeof MuiButton>;

const Button: FC<Props> = (props) => {
    return <MuiButton {...props} />
}

export default Button;